<template>
<div>
  <v-toolbar dense style=" position: fixed;">
    </v-toolbar-items>
    <v-btn class="orange darken-2 white--text" v-on:click.native="terugClicked" > <v-icon dark left>arrow_back</v-icon>Terug</v-btn>
    <v-btn style="margin: 0px;margin-left: 20px;" v-bind:class="{grey : AlgemeenSelected}" v-on:click.native="AlgemeenClicked" :disabled="loading">Algemeen</v-btn>
    <v-btn style="margin: 0px;" v-bind:class="{grey : OnderhoudSelected}" v-on:click.native="OnderhoudClicked" :disabled="loading">Onderhoud</v-btn>
    <v-btn style="margin: 0px;" v-bind:class="{grey : KeuringSelected}" v-on:click.native="KeuringClicked" :disabled="loading">Keuring</v-btn>
    <v-btn style="margin: 0px;" v-bind:class="{grey : BestandenSelected}" v-on:click.native="BestandenClicked" :disabled="loading">Bestanden</v-btn>
    <v-btn style="margin: 0px;" v-bind:class="{grey : SteekkaartSelected}" v-on:click.native="SteekkaartClicked" :disabled="loading">Steekkaart</v-btn>
    <v-spacer></v-spacer>
    <v-btn style="margin: 0px;" class="blue white--text" v-on:click.native="afdrukkenClicked" :disabled="loading"><v-icon dark>print</v-icon></v-btn>
    <v-btn style="margin: 0px;" class="green white--text"  v-on:click.native="opslaanClicked" :disabled="loading"><v-icon dark>save</v-icon></v-btn>
    <v-btn style="margin: 0px;" class="red white--text"  v-on:click.native="verwijderenClicked" :disabled="loading"><v-icon dark>delete</v-icon></v-btn>

  </v-toolbar>

  <div style="  height: 50px;">
  </div>
  <div v-if="loading" class="text-xs-center elevation-12" style="width: 60%; min-width: 400px; margin-left: auto; margin-right: auto;margin-top: 20px; margin-bottom: 20px; padding: 10px;">
    <div style="width: 120px; height: 120px;margin:auto; padding-top: 20px; padding-left: 20px;">
      <v-progress-circular indeterminate v-bind:size="80" v-bind:width="5" class="orange--text"></v-progress-circular>
    </div>
  </div>

  <div v-show="!loading">
    <div v-show="AlgemeenSelected" class="text-xs-center elevation-12" style="width: 60%; min-width: 400px; margin-left: auto; margin-right: auto;margin-top: 20px; margin-bottom: 20px; padding: 10px;">
      <v-layout style="margin: auto;padding:auto; margin-right: 0px;" row wrap>
            <v-flex xs4 >
              <div style="text-align: right;font-weight: bold">
                Soort:
              </div>
            </v-flex>
            <v-flex xs8 >
              <div style="text-align: left; margin-left: 10px;">
                {{soorttxt}}
              </div>
            </v-flex>
            <v-flex xs4 >
              <div style="text-align: right;font-weight: bold">
                Volgnr:
              </div>
            </v-flex>
            <v-flex xs4 >
              <div style="text-align: left; margin-left: 10px;">
                {{volgnr}}
              </div>
            </v-flex>
            <v-flex xs4 >
              <div style="text-align: right; margin-left: 10px;">
                <v-btn style="margin: 0px;height:20px;font-size: 10px;" v-on:click.native="wijzigvolgnrClicked" :disabled="loading">wijzig volgnr</v-btn>
              </div>
            </v-flex>
            <v-flex xs4 >
              <div style="text-align: right;font-weight: bold;height:32px;line-height:32px;">
                Type:
              </div>
            </v-flex>
            <v-flex xs8 >
              <div style="text-align: left; margin-left: 10px;">
                <v-text-field style="margin: 0px;"
                    hide-details
                    v-model="omschrijving"
                    @input="dataGewijzigd"
                  ></v-text-field>
              </div>
            </v-flex>

            <v-flex xs4 >
              <div style="text-align: right;font-weight: bold;height:32px;line-height:32px;">
                Merk:
              </div>
            </v-flex>
            <v-flex xs8 >
              <div style="text-align: left; margin-left: 10px;">
                <v-text-field style="margin: 0px;"
                    hide-details
                    v-model="merk"
                    @input="dataGewijzigd"
                  ></v-text-field>
              </div>
            </v-flex>

            <v-flex xs4 >
              <div style="text-align: right;font-weight: bold;height:32px;line-height:32px;">
                Bouwjaar:
              </div>
            </v-flex>
            <v-flex xs8 >
              <div style="text-align: left; margin-left: 10px;">
                <v-text-field style="margin: 0px;"
                    hide-details
                    v-model="bouwjaar"
                    @input="dataGewijzigd"
                  ></v-text-field>
              </div>
            </v-flex>

            <v-flex xs4 >
              <div style="text-align: right;font-weight: bold;height:32px;line-height:32px;">
                Serienr:
              </div>
            </v-flex>
            <v-flex xs8 >
              <div style="text-align: left; margin-left: 10px;">
                <v-text-field style="margin: 0px;"
                    hide-details
                    v-model="serienr"
                    @input="dataGewijzigd"
                  ></v-text-field>
              </div>
            </v-flex>

            <v-flex xs4 >
              <div style="text-align: right;font-weight: bold;height:32px;line-height:32px;">
                HL
              </div>
            </v-flex>
            <v-flex xs8 >
              <div style="text-align: left; margin-left: 10px;">
                <v-checkbox style="margin: 0px;" hide-details v-model="HL" @change="dataGewijzigd"></v-checkbox>
              </div>
            </v-flex>

            <v-flex xs4 >
              <div style="text-align: right;font-weight: bold;height:32px;line-height:32px;">
                VIK
              </div>
            </v-flex>
            <v-flex xs8 >
              <div style="text-align: left; margin-left: 10px;">
                <v-checkbox style="margin: 0px;" hide-details v-model="VIK" @change="dataGewijzigd"></v-checkbox>
              </div>
            </v-flex>

            <v-flex xs4 >
              <div style="text-align: right;font-weight: bold;height:32px;line-height:32px;">
                RIE
              </div>
            </v-flex>
            <v-flex xs8 >
              <div style="text-align: left; margin-left: 10px;">
                <v-checkbox style="margin: 0px;" hide-details v-model="RIE" @change="dataGewijzigd"></v-checkbox>
              </div>
            </v-flex>

            <v-flex xs4 >
              <div style="text-align: right;font-weight: bold;height:32px;line-height:32px;">
                CE
              </div>
            </v-flex>
            <v-flex xs8 >
              <div style="text-align: left; margin-left: 10px;">
                <v-checkbox style="margin: 0px;" hide-details v-model="CE" @change="dataGewijzigd"></v-checkbox>
              </div>
            </v-flex>

            <v-flex xs4 >
              <div style="text-align: right;font-weight: bold;height:32px;line-height:32px;">
                IDV
              </div>
            </v-flex>
            <v-flex xs8 >
              <div style="text-align: left; margin-left: 10px;">
                <v-checkbox style="margin: 0px;" hide-details v-model="IDV" @change="dataGewijzigd"></v-checkbox>
              </div>
            </v-flex>


<v-flex xs12 ><br></v-flex>

            <v-flex xs4 >
              <div style="text-align: right;font-weight: bold">
                Huidige locatie:
              </div>
              <div style="text-align: right;">
                {{datlocstr}}
              </div>
            </v-flex>
            <v-flex xs8 >
              <div style="text-align: left; margin-left: 10px;">
                <v-autocomplete
                      v-bind:items="locdata"
                      v-model="selectedWerfNr"
                      item-text="text"
                      item-value="werfnr"
                      label=""
                      single-line
                      no-data-text="Geen Gegevens"
                      @change="dataGewijzigd"
                    ></v-autocomplete>
              </div>
            </v-flex>
            <v-flex xs4 >
              <div style="text-align: right;font-weight: bold">
                Vorige locaties:
              </div>
              <div style="text-align: right;">
              </div>
              <div style="text-align: right;">
              </div>
            </v-flex>
            <v-flex xs8 >
              <div style="text-align: left; margin-left: 10px;">
                {{selectedWerf2.text}} {{datloc2str}}
              </div>
              <div style="text-align: left; margin-left: 10px;">
                {{selectedWerf3.text}} {{datloc3str}}
              </div>
            </v-flex>
          </v-layout>
    </div>


    <div v-show="OnderhoudSelected" class="text-xs-center elevation-12" style="width: 60%; min-width: 400px; margin-left: auto; margin-right: auto;margin-top: 20px; margin-bottom: 20px; padding: 10px;">
      <v-layout style="margin: auto;padding:auto; margin-right: 0px;" row wrap>

        <v-flex xs12 >
          <div style="text-align: left; margin-left: 10px;">
            <b>Soort:</b> {{soorttxt}}
          </div>
          <div style="text-align: left; margin-left: 10px;">
            <b>Volgnr:</b> {{volgnr}}
          </div>
          <div style="text-align: left; margin-left: 10px;font-weight: bold;">
            {{omschrijving}}
          </div>
        </v-flex>
        <v-flex xs12 ><br></v-flex>
        <v-flex xs4 >
          <div style="text-align: left; margin-left: 10px;">
            defect
          </div>
        </v-flex>
        <v-flex xs8 >
          <div style="text-align: left; margin-left: 10px;">
            <v-checkbox style="margin: 0px;" hide-details v-model="defect" @change="dataGewijzigd"></v-checkbox>
          </div>
        </v-flex>
        <v-flex xs4 >
          <div style="text-align: left; margin-left: 10px;">
            vorstvrij
          </div>
        </v-flex>
        <v-flex xs8 >
          <div style="text-align: left; margin-left: 10px;">
            <v-checkbox style="margin: 0px;" hide-details v-model="vorstvrij" @change="dataGewijzigd"></v-checkbox>
          </div>
        </v-flex>
        <v-flex xs12 ><br></v-flex>
        <v-flex xs4 style="margin: 0px;padding:0px;padding-left: 10px;" >
          <v-btn style="text-align: center; margin-left: 0px;" :outline="datumingave" block @click.native="datumingaveClick">Datum-ingave</v-btn>
        </v-flex>
        <v-flex xs4 style="margin: 0px;padding:0px;">
          <v-btn style="text-align: center; margin-left: 0px;" :outline="ureningave" block @click.native="ureningaveClick">Uren-ingave</v-btn>
        </v-flex>
        <v-flex xs4 style="margin: 0px;padding:0px;padding-right: 10px;">
          <v-btn style="text-align: center; margin-left: 0px;" :outline="infoingave" block @click.native="infoingaveClick">Info-ingave</v-btn>
        </v-flex>

      <v-container v-show="datumingave" style="margin: 0px;padding:0px;margin-left: 10px; margin-right: 10px;border-style: solid;border-width: 1px;">





        <v-flex xs12 style="margin: 0px;padding:0px;">
          <div style="text-align: left; margin-left: 5px;margin-right: 10px;">
            <span class="group pa-1" >
              <v-icon>event</v-icon>
              <div style="margin-left: 15px;">Datum volgend onderhoud:</div>
              <div class="dateclass">
              <datepicker v-model="datumvolgend" selected="dataGewijzigd" placeholder="__/__/____" monday-first format="dd/MM/yyyy" language="nl"></datepicker>
              </div>
            </span>
          </div>
        </v-flex>


        <v-flex xs12 style="margin: 0px;padding:0px;">
          <div style="text-align: left; margin-left: 5px;margin-right: 10px;">
            <span class="group pa-1" >
              <v-icon>event</v-icon>
              <div style="margin-left: 15px;margin-right: 18px;">Datum vorig onderhoud:</div>
              <div class="dateclass">
              <datepicker v-model="datumvorig" selected="dataGewijzigd" placeholder="__/__/____" monday-first format="dd/MM/yyyy" language="nl"></datepicker>
              </div>
            </span>
          </div>
        </v-flex>



            </v-container>

            <v-container v-show="ureningave" style="margin: 0px;padding:0px;margin-left: 10px; margin-right: 10px;border-style: solid;border-width: 1px;">
              <v-flex xs12 style="margin: 0px;padding:0px;">
                <div style="text-align: right; margin-left: 10px;margin-right: 10px;">
                  <v-text-field
                    label="Huidige urenstand/kilometerstand"
                    prepend-icon="timer"
                    v-model="huidigeurenstand"
                    hide-details
                    @input="dataGewijzigd"
                  ></v-text-field>
                </div>
              </v-flex>
              <v-flex xs12 style="margin: 0px;padding:0px;">
                <div style="text-align: left; margin-left: 5px;margin-right: 10px;">
                  <span class="group pa-1" >
                    <v-icon>event</v-icon>
                    <div style="margin-left: 15px;">Opgenomen op:</div>
                    <div class="dateclass">
                    <datepicker v-model="datumurenopgenomenop" selected="dataGewijzigd" placeholder="__/__/____" monday-first format="dd/MM/yyyy" language="nl"></datepicker>
                    </div>
                  </span>
                </div>
              </v-flex>
              <v-flex xs12 style="margin: 0px;padding:0px;">
                <div style="text-align: right; margin-left: 10px;margin-right: 10px;">
                  <v-text-field
                    label="Urenstand/kilometerstand vorig onderhoud"
                    prepend-icon="timer"
                    v-model="vorigeurenstand"
                    hide-details
                    @input="dataGewijzigd"
                  ></v-text-field>
                </div>
              </v-flex>
              <v-flex xs12 style="margin: 0px;padding:0px;">
                <div style="text-align: right; margin-left: 10px;margin-right: 10px;">
                  <v-text-field
                    label="Interval onderhoud (uren of km)"
                    prepend-icon="timer"
                    v-model="omde"
                    hide-details
                    @input="dataGewijzigd"
                  ></v-text-field>
                </div>
              </v-flex>
      </v-container>



      <v-flex xs12 ><br></v-flex>
      <v-container style="margin: 0px;padding:0px;margin-left: 10px; margin-right: 10px;background-color: lightgrey;">
        Onderhoudsinformatie
      </v-container>
      <v-container style="margin: 0px;padding:0px;margin-left: 10px; margin-right: 10px;border-style: solid;border-width: 1px;">


        <v-flex xs12 style="margin: 0px;padding:0px;">
          <div style="text-align: left; margin-left: 5px;margin-right: 10px;">
            <span class="group pa-1" >
              <v-icon>event</v-icon>
              <div class="dateclass">
              <datepicker v-model="datumNieuwOnderhoud" selected="dataGewijzigd" placeholder="__/__/____" monday-first format="dd/MM/yyyy" language="nl"></datepicker>
              </div>
            </span>
          </div>
        </v-flex>


        <v-layout row wrap style="margin: 0px;padding:0px;margin-left: 10px; margin-right: 10px;">

                    <v-textarea
                      label="Gegevens invullen"
                      class="input-group--focused"
                      v-model="nieuweonderhoudgegevens"
                      hide-details
                    ></v-textarea>
                    <v-btn class="green white--text" style="padding: 0px;margin-bottom: 0px;"  v-on:click.native="nieuwOnderhoudClicked" small fab><v-icon style="padding: 0px;" dark>add</v-icon></v-btn>


                  <v-flex xs12>
                    <v-textarea style="background-color: lightgrey;"
                      placeholder="-geen historiek-"
                      v-model="onderhoudtekst"
                      class="input-group--focused"
                      hide-details
                    ></v-textarea>
                  </v-flex>


        </v-layout>


      </v-container>

          </v-layout>
    </div>

    <div v-show="KeuringSelected" class="text-xs-center elevation-12" style="width: 60%; min-width: 400px; margin-left: auto; margin-right: auto;margin-top: 20px; margin-bottom: 20px; padding: 10px;">
      <v-layout style="margin: auto;padding:auto; margin-right: 0px;" row wrap>

        <v-flex xs12 >
          <div style="text-align: left; margin-left: 10px;">
            <b>Soort:</b> {{soorttxt}}
          </div>
          <div style="text-align: left; margin-left: 10px;">
            <b>Volgnr:</b> {{volgnr}}
          </div>
          <div style="text-align: left; margin-left: 10px;font-weight: bold;">
            {{omschrijving}}
          </div>
        </v-flex>
        <v-flex xs12 ><br></v-flex>

        <v-flex xs6 style="margin: 0px;padding:0px;padding-left: 10px;" >
          <v-btn style="text-align: center; margin-left: 0px;" :outline="keuringinex==0" block @click.native="keuringinexClick(0)">INTERN</v-btn>
        </v-flex>
        <v-flex xs6 style="margin: 0px;padding:0px;">
          <v-btn style="text-align: center; margin-left: 0px;" :outline="keuringinex==1" block @click.native="keuringinexClick(1)">EXTERN</v-btn>
        </v-flex>

        <v-flex xs4 style="margin: 0px;padding:0px;padding-left: 10px;" >
          <v-btn style="text-align: center; margin-left: 0px;" :outline="omdemaanden==3" block @click.native="omdemaandenClick(3)">3-maandelijks</v-btn>
        </v-flex>
        <v-flex xs4 style="margin: 0px;padding:0px;">
          <v-btn style="text-align: center; margin-left: 0px;" :outline="omdemaanden==6" block @click.native="omdemaandenClick(6)">6-maandelijks</v-btn>
        </v-flex>
        <v-flex xs4 style="margin: 0px;padding:0px;padding-right: 10px;">
          <v-btn style="text-align: center; margin-left: 0px;" :outline="omdemaanden==12" block @click.native="omdemaandenClick(12)">jaarlijks</v-btn>
        </v-flex>

      <v-flex xs12 ><br></v-flex>
      <v-container style="margin: 0px;padding:0px;margin-left: 10px; margin-right: 10px;border-style: solid;border-width: 1px;">

        <v-flex xs12 style="margin: 0px;padding:0px;">
          <div style="text-align: left; margin-left: 5px;margin-right: 10px;">
            <span class="group pa-1" >
              <v-icon>event</v-icon>
              <div class="dateclass">
              <datepicker v-model="datumNieuweKeuring" selected="dataGewijzigd" placeholder="__/__/____" monday-first format="dd/MM/yyyy" language="nl"></datepicker>
              </div>
            </span>
          </div>
        </v-flex>

        <v-layout row wrap style="margin: 0px;padding:0px;margin-left: 10px; margin-right: 10px;">
                    <v-textarea
                      label="Opmerkingen keuringsverslag"
                      class="input-group--focused"
                      v-model="nieuwekeuringgegevens"

                      hide-details
                    ></v-textarea>
                    <v-btn class="green white--text" style="padding: 0px;margin-bottom: 0px;"  v-on:click.native="nieuwKeuringClicked" small fab><v-icon style="padding: 0px;" dark>add</v-icon></v-btn>
                  <v-flex xs12>
                    <v-textarea style="background-color: lightgrey;"
                      placeholder="-geen keuringsverslagen-"
                      v-model="keuringtekst"
                      class="input-group--focused"
                      hide-details
                    ></v-textarea>
                  </v-flex>
        </v-layout>
      </v-container>

          </v-layout>
    </div>

    <div v-show="BestandenSelected" class="text-xs-center elevation-12" style="width: 60%; min-width: 400px; margin-left: auto; margin-right: auto;margin-top: 20px; margin-bottom: 20px; padding: 10px;">
      <v-layout style="margin: auto;padding:auto; margin-right: 0px;" row wrap>

        <v-flex xs12 >
          <div style="text-align: left; margin-left: 10px;">
            <b>Soort:</b> {{soorttxt}}
          </div>
          <div style="text-align: left; margin-left: 10px;">
            <b>Volgnr:</b> {{volgnr}}
          </div>
          <div style="text-align: left; margin-left: 10px;font-weight: bold;">
            {{omschrijving}}
          </div>
        </v-flex>
        <v-flex xs12 ><br></v-flex>
      <v-container style="margin: 0px;padding:0px;margin-left: 10px; margin-right: 10px;border-style: solid;border-width: 1px;">
        <v-flex xs12 style="margin: 0px;padding:0px;">
          <div style="text-align: right; margin-left: 10px;margin-right: 10px;">
            <v-text-field
              label="Mapnaam op server"
              v-model="mapnaam"
              prepend-icon="folder"
              hide-details
            ></v-text-field>
          </div>
        </v-flex>
        <v-flex xs12 v-if="bestandenLoading" style="text-align: center; margin: 20px;">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
          </v-flex>
          <v-list style="margin-left: 10px;margin-right: 10px;" v-if="!bestandenLoading">
          <template v-for="item in filelist">
            <v-list-tile @click.native="clickFile(item)">
              <v-list-tile-content>
                {{item.title}}
              </v-list-tile-content>
            </v-list-tile>

          </template>
        </v-list>
      </v-container>

          </v-layout>
    </div>

    <div v-show="SteekkaartSelected" class="text-xs-center elevation-12" style="width: 60%; min-width: 400px; margin-left: auto; margin-right: auto;margin-top: 20px; margin-bottom: 20px; padding: 10px;">
      <v-layout style="margin: auto;padding:auto; margin-right: 0px;" row wrap>

          <v-flex xs3 ><div style="text-align: right; margin-left: 10px;font-weight: bold;">
              Nummer:
          </div></v-flex>
          <v-flex xs3 ><div style="text-align: left; margin-left: 10px;">
              {{soortIDshortTxt}}
          </div></v-flex>
          <v-flex xs3 ><div style="text-align: right; margin-left: 10px;font-weight: bold;">
              Vorstvrij:
          </div></v-flex>
          <v-flex xs3 ><div style="text-align: left; margin-left: 10px;">
              <div v-if="vorstvrij">JA</div><div v-if="!vorstvrij">NEE</div>
          </div></v-flex>
          <v-flex xs3 ><div style="text-align: right; margin-left: 10px;font-weight: bold;">
              Soort:
          </div></v-flex>
          <v-flex xs3 ><div style="text-align: left; margin-left: 10px;">
              {{soortdesc}}
          </div></v-flex>
          <v-flex xs3 ><div style="text-align: right; margin-left: 10px;font-weight: bold;">
              Defect:
          </div></v-flex>
          <v-flex xs3 ><div style="text-align: left; margin-left: 10px;">
              <div v-if="defect">JA</div><div v-if="!defect">NEE</div>
          </div></v-flex>
          <v-flex xs12 ><br></v-flex>
          <v-flex xs3 ><div style="text-align: right; margin-left: 10px;font-weight: bold;">
              omschrijving:
          </div></v-flex>
          <v-flex xs9 ><div style="text-align: left; margin-left: 10px;">
              {{omschrijving}}
          </div></v-flex>

          <v-flex xs12 style="background-color: black;height: 2px;margin-top: 15px;"><div style="width: 1px;height: 2px;"></div></v-flex>
          <v-flex xs12 ><br></v-flex>

          <v-flex xs3 ><div style="text-align: right; margin-left: 10px;font-weight: bold;">
              Huidige locatie:
          </div></v-flex>
          <v-flex xs9 ><div style="text-align: left; margin-left: 10px;">
              {{selectedWerfNr}} {{datlocstr}}
          </div></v-flex>
          <v-flex xs3 ><div style="text-align: right; margin-left: 10px;">
              voorgaande locatie 1:
          </div></v-flex>
          <v-flex xs9 ><div style="text-align: left; margin-left: 10px;">
              {{selectedWerf2.text}} {{datloc2str}}
          </div></v-flex>
          <v-flex xs3 ><div style="text-align: right; margin-left: 10px;">
              voorgaande locatie 2:
          </div></v-flex>
          <v-flex xs9 ><div style="text-align: left; margin-left: 10px;">
              {{selectedWerf3.text}} {{datloc3str}}
          </div></v-flex>

          <v-flex xs12 style="background-color: black;height: 2px;margin-top: 15px;"><div style="width: 1px;height: 2px;"></div></v-flex>
          <v-flex xs12 ><br></v-flex>

          <v-flex xs3 v-if="ureningave"><div style="text-align: right; margin-left: 10px;font-weight: bold;">
              Urenstand:
          </div></v-flex>
          <v-flex xs9 v-if="ureningave"><div style="text-align: left; margin-left: 10px;">
              {{huidigeurenstand}} u
          </div></v-flex>
          <v-flex xs3 v-if="ureningave"><div style="text-align: right; margin-left: 10px;">
              Vorig onderhoud:
          </div></v-flex>
          <v-flex xs9 v-if="ureningave"><div style="text-align: left; margin-left: 10px;">
              {{vorigeurenstand}} u
          </div></v-flex>
          <v-flex xs3 v-if="ureningave"><div style="text-align: right; margin-left: 10px;">
              Interval onderhoud:
          </div></v-flex>
          <v-flex xs9 v-if="ureningave"><div style="text-align: left; margin-left: 10px;">
              {{omde}} u
          </div></v-flex>
          <v-flex xs3 v-if="ureningave"><div style="text-align: right; margin-left: 10px;">
              nog
          </div></v-flex>
          <v-flex xs9 v-if="ureningave"><div style="text-align: left; margin-left: 10px;">
              {{omde + vorigeurenstand - huidigeurenstand}} u voor volgend onderhoud
          </div></v-flex>

          <v-flex xs3 v-if="datumingave"><div style="text-align: right; margin-left: 10px;font-weight: bold;">
              Volgend onderhoud:
          </div></v-flex>
          <v-flex xs9 v-if="datumingave"><div style="text-align: left; margin-left: 10px;">
            __/__/____
          </div></v-flex>

          <v-flex xs12 style="background-color: black;height: 2px;margin-top: 15px;"><div style="width: 1px;height: 2px;"></div></v-flex>
          <v-flex xs12 ><br></v-flex>

          <v-flex xs12 style="background-color: lightyellow;font-weight: bold;">Onderhoudsgeschiedenis</v-flex>
          <v-flex xs12 style="background-color: lightgrey;word-break: break-all;white-space: pre-line;text-align: left;">{{onderhoudtekst}}</v-flex>
          <v-flex xs12 style="background-color: lightyellow;font-weight: bold;">Keuringsgeschiedenis</v-flex>
          <v-flex xs12 style="background-color: lightgrey;word-break: break-all;white-space: pre-line;text-align: left;">{{keuringtekst}}</v-flex>

      </v-layout>



    </div>


    <v-layout row justify-center style="position: relative;">
      <v-dialog v-model="showSaveDialog" width="350px" absolute persistent>
        <v-card>
          <v-card-title>
            <div class="headline">Wijzigingen opslaan?</div>
          </v-card-title>
          <v-card-actions>
            <v-btn dark @click.native="saveDialogOpslaan">Opslaan</v-btn>
            <v-btn dark @click.native="saveDialogNietOpslaan">Niet opslaan</v-btn>
            <v-btn dark @click.native="saveDialogAnnuleren">Annuleren</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>

  <v-layout row justify-center style="position: relative;">
    <v-dialog v-model="showVerwijderDialog" width="350px" absolute persistent>
      <v-card style="background-color: red;">
        <v-card-title>
          <div class="headline white--text">Machine verwijderen?</div>
        </v-card-title>
        <v-card-actions>
          <v-btn dark @click.native="showVerwijderDialog = false">Annuleren</v-btn>
          <v-spacer></v-spacer>
          <v-btn dark @click.native="verwDialogVerwijderen">Verwijderen</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>



    <v-layout row justify-center style="position: relative;">
      <v-dialog v-model="showWijzigVolgnrDialog" width="350px" absolute persistent>
        <v-card >
          <v-card-title>
            <div class="headline">Wijzig soort/volgnr</div>
          </v-card-title>
          <v-card-text>
            <v-select
                         v-bind:items="soortendata"
                         v-model="nieuweMachineSoort"
                         item-text="text"
                         item-value="soortID"
                         return-object
                         label="soort"
                         single-line
                         required
                         no-data-text="Geen Gegevens"
                       ></v-select>
            <v-text-field v-model="nieuweVolgnr" label="volgnr" required></v-text-field>
            <div class="red--text" v-if="TErrorShow">{{TErrorWijzigVolgnr}}</div>
          </v-card-text>
          <v-card-actions>
            <v-btn dark @click.native="showWijzigVolgnrDialog = false">Annuleren</v-btn>
            <v-spacer></v-spacer>
            <v-btn dark @click.native="WijzigVolgnrDialogClicked">OK</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>

















</div>


</div>
</template>

<script>
import datareq from './datareq.js'
import functions from './functions.js'
import Jspdf from 'jspdf'
import autotable from 'jspdf-autotable'
import Datepicker from 'vuejs-datepicker'

  export default {
    components: {
      datareq,
      functions,
      Jspdf,
      autotable,
      Datepicker
    },
    created: function () {
      this.$bus.$on('laadMaterieelDetail', this.laden)
    },
    props: {
      werven: Array,
      soortendata: Array
    },
    data () {
      return {
        AlgemeenSelected: true,
        OnderhoudSelected: false,
        KeuringSelected: false,
        BestandenSelected: false,
        SteekkaartSelected: false,
        showVerwijderDialog: false,
        showWijzigVolgnrDialog: false,
        soorttxt: '',
        omschrijving: '',
        selectedWerfNr: '',
        selectedWerf2: [],
        selectedWerf3: [],
        datloc: '',
        datloc2: '',
        datloc3: '',
        datlocstr: '',
        datloc2str: '',
        datloc3str: '',
        receivedCounter: 0,
        machine: [],
        datagew: false,
        locdata: [],
        locvalues: [],
        showSaveDialog: false,
        sluitennaopslaan: false,
        datumingave: false,
        ureningave: false,
        infoingave: false,
        datumvorig: null,
        datumvolgend: null,
        datumurenopgenomenop: null,
        showdatumpicker: false,
        defect: 0,
        vorstvrij: 0,
        HL: 0,
        VIK: 0,
        RIE: 0,
        CE: 0,
        IDV: 0,
        datumtype: '',
        huidigeurenstand: 0,
        vorigeurenstand: 0,
        omde: 0,
        onderhoudtekst: '',
        keuringtekst: '',
        nieuweonderhoudgegevens: '',
        nieuwekeuringgegevens: '',
        months: ['januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december'],
        days: ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag'],
        wasdatumnull: false,
        sid: '',
        vid: '',
        omdemaanden: 3,
        keuringinex: 0,
        merk:'',
        bouwjaar: '2017',
        serienr: '',
        datumNieuwOnderhoud: null,
        datumNieuweKeuring: null,
        geldigtot: '',
        mapnaam: '',
        filelist: [
        ],
        soortIDshortTxt: '',
        soortdesc: '',
        volgnr: '',
        TErrorWijzigVolgnr: '',
        TErrorShow: false,

        nieuweMachineSoort: [],
        nieuweVolgnr: '',

        loading: false,
        bestandenLoading: false
      }
    },
    methods: {
      resetAll: function () {
        this.AlgemeenSelected = false
        this.OnderhoudSelected = false
        this.KeuringSelected = false
        this.BestandenSelected = false
        this.SteekkaartSelected = false
      },
      herladen: function () {
        this.laden([{sid: this.sid, vid: this.vid}])
      },
      laden: function (data) {
        this.resetAll()
        this.datagew = false
        this.AlgemeenSelected = true
        this.loading = true
        this.receivedCounter = 0
        this.machine = []
        this.selectedWerf = ''
        this.selectedWerf2 = []
        this.selectedWerf3 = []
        this.datloc = ''
        this.datloc2 = ''
        this.datloc3 = ''
        this.datumvorig = null
        this.datumvolgend = null

        this.sluitennaopslaan = false
        this.defect = false
        this.vorstvrij = false
        this.HL = false
        this.VIK = false
        this.RIE = false
        this.CE = false
        this.IDV = false

        this.datumingave = false
        this.ureningave = false
        this.infoingave = false

        this.huidigeurenstand = 0
        this.vorigeurenstand = 0
        this.omde = 0
        this.onderhoudtekst = ''
        this.keuringtekst= ''
        this.nieuweonderhoudgegevens = ''
        this.nieuwekeuringgegevens = ''
        this.omdemaanden = 3
        this.keuringinex = 0
        this.merk = ''
        this.bouwjaar = '2017'
        this.serienr = ''
        this.geldigtot = ''
        this.volgnr = ''


        var sid = data[0].sid
        var vid = data[0].vid

        this.sid = sid
        this.vid = vid
        this.mapnaam = ''

        this.datumNieuwOnderhoud = functions.vandaag()
        this.datumNieuweKeuring = functions.vandaag()

        datareq.getData('GetMachineWithID', {soortID: sid, volgID: vid}, this.jsonMachineReceived)
        // Bestandenlijst wordt nu pas geladen bij openen van het tab
        //datareq.getData('GetMachines', {IDFilter: this.IDfilter, materieelfilter: this.materieelfilter, LOCFilter: this.LOCfilter, DefectFilter: this.Defectfilter, VorstvrijFilter: this.Vorstvrijfilter, UrofkmFilter: this.UrofkmFilter, PeriodiekeFilter: this.PeriodiekeFilter, perpagina : this.perpagina, pagina: this.pagina}, this.jsonMaterieelReceived)
      },
      dataGewijzigd: function () {
        if(!this.loading) {
          this.datagew = true
        }
      },
      jsonMachineReceived: function (data) {
        var status = data.status
        if (status === 'OK') {

          this.receivedCounter = this.receivedCounter + 1
          var d = data.data[0]
          this.machine = d
          //console.log(d)
        } else {
        }
        this.checkFinished()
      },
      jsonMachineFilesReceived: function (data) {
        var status = data.status
        if (status === 'OK') {

          var d = data.data
          this.filelist = []
          for (var s of d) {
            var n = {title: s, url: s}
            this.filelist.push(n)
          }
          this.bestandenLoading = false
        }
      },
      checkFinished: function () {
        if (this.receivedCounter === 1) {

          this.receivedCounter = 0

          this.soortID = this.machine.soortID

          this.soortIDshortTxt = this.machine.soortID + '.' + this.machine.volgnr
          this.volgnr = this.machine.volgnr
          this.soortdesc = this.machine.soort

          this.soorttxt = this.machine.soortID + ' - ' + this.machine.soort
          this.omschrijving = this.machine.omschr

          this.locdata = []
          this.locvalues = []
          var selwerfobj = {}
          var selwerfobj2 = {}
          var selwerfobj3 = {}

          for (var w of this.werven) {
            var n = {text: w.werfnr + ' - ' + w.werfnaam, werfnr: w.werfnr}
            if(this.machine.locID === w.werfnr) {
              selwerfobj = n
            }
            if(this.machine.locID2 === w.werfnr) {
              selwerfobj2 = n
            }
            if(this.machine.locID3 === w.werfnr) {
              selwerfobj3 = n
            }
            this.locdata.push(n)
          }

          this.selectedWerfNr = selwerfobj.werfnr
          this.selectedWerf2 = selwerfobj2
          this.selectedWerf3 = selwerfobj3

          this.datloc = this.machine.datLOC
          this.datloc2 = this.machine.datLOC2
          this.datloc3 = this.machine.datLOC3

          this.datlocstr = functions.calcDatLocStr(this.datloc)
          this.datloc2str = functions.calcDatLocStr(this.datloc2)
          this.datloc3str = functions.calcDatLocStr(this.datloc3)

          this.defect = this.machine.defect
          this.vorstvrij = this.machine.vorstvrij
          this.HL = this.machine.HL
          this.VIK = this.machine.VIK
          this.RIE = this.machine.RIE
          this.CE = this.machine.CE
          this.IDV = this.machine.IDV
          this.huidigeurenstand = this.machine.urofkm
          this.datumurenopgenomenop = functions.str2datOrNull(this.machine.opgenomenop)
          this.vorigeurenstand = this.machine.urofkm2
          this.omde = this.machine.omde
          this.datumvorig = functions.str2datOrNull(this.machine.datvonderh)
          this.datumvolgend = functions.str2datOrNull(this.machine.datonderh)

          if(this.machine.datofuren === 0) {
            this.datumingave = false
            this.ureningave = true
            this.infoingave = false
          }
          if(this.machine.datofuren === 1) {
            this.datumingave = true
            this.ureningave = false
            this.infoingave = false
          }
          if(this.machine.datofuren === 2) {
            this.datumingave = false
            this.ureningave = false
            this.infoingave = true
          }

          this.onderhoudtekst = this.machine.onderhoudtekst
          this.keuringtekst = this.machine.keuringopmtekst
          this.geldigtot = this.machine.geldigtot

          this.omdemaanden = this.machine.omdemaanden
          this.mapnaam = this.machine.mapnaam

          this.keuringinex = this.machine.keuringinex
          this.merk = this.machine.merk
          this.serienr = this.machine.serienr
          this.bouwjaar = this.machine.bouwjaar

          this.nieuweMachineSoort = []
          this.nieuweVolgnr = this.volgnr

          this.loading = false
          this.datagew = false
        }
      },
      AlgemeenClicked: function () {
        this.resetAll()
        this.AlgemeenSelected = true
      },
      OnderhoudClicked: function () {
        this.resetAll()
        this.OnderhoudSelected = true
      },
      KeuringClicked: function () {
        this.resetAll()
        this.KeuringSelected = true
      },
      BestandenClicked: function () {
        this.resetAll()
        this.BestandenSelected = true
        if (this.filelist.length === 0) {
          this.bestandenLoading = true
          datareq.getData('GetMachineBestandenLijstWithID', {sid: this.sid, vid: this.vid}, this.jsonMachineFilesReceived)
        }
      },
      SteekkaartClicked: function () {
        this.resetAll()
        this.SteekkaartSelected = true
      },
      terugClicked: function () {
        if (this.datagew) {
          this.showSaveDialog = true
        } else {
          this.$emit('backMaterieel')
        }


      },
      afdrukkenClicked: function () {
        var o = {};

        o.omschrijving = this.omschrijving;
        o.soortID = this.soortID
        o.volgnr = this.volgnr
        o.vorstvrij = this.vorstvrij
        o.soortdesc = this.soortdesc
        o.defect = this.defect
        o.selectedWerfText = this.selectedWerfNr
        o.datlocstr = this.datlocstr
        o.selectedWerf2Text = this.selectedWerf2.text
        o.datloc2str = this.datloc2str
        o.selectedWerf3Text = this.selectedWerf3.text
        o.datloc3str = this.datloc3str
        o.huidigeurenstand = this.huidigeurenstand
        o.datumurenopgenomenop = this.datumurenopgenomenop
        o.vorigeurenstand = this.vorigeurenstand
        o.omde = this.omde
        o.onderhoudtekst = this.onderhoudtekst
        o.keuringtekst = this.keuringtekst
        o.ureningave = this.ureningave

        var lijst = [o];
        functions.afdrukkenSteekkaart(lijst)
      },
      verwDialogVerwijderen: function () {
        datareq.getData('VerwijderMachineWithID', {soortID: this.sid, volgID: this.vid}, this.jsonMachineVerwijderd)
      },
      jsonMachineVerwijderd: function () {
        this.showVerwijderDialog = false
        this.$emit('backMaterieel')
      },
      opslaanClicked: function () {
        this.sluitennaopslaan = false
        this.machineOpslaan()
      },
      verwijderenClicked: function () {
        this.showVerwijderDialog = true
      },
      wijzigvolgnrClicked: function () {
        this.showWijzigVolgnrDialog = true
      },
      jsonMachineOpslaan: function () {
        this.datagew = false
        this.loading = false
        if(this.sluitennaopslaan) {
          this.showSaveDialog = false
          this.$emit('backMaterieel')
        } else {
          this.herladen()
        }
      },
      machineOpslaan: function () {
        this.loading = true
        var m = {}

        m.soortID = this.sid
        m.volgID = this.vid
        m.omschr = this.omschrijving

        if(this.selectedWerfNr === this.machine.locID) {
          m.locID = this.machine.locID
          m.locID2 = this.machine.locID2
          m.locID3 = this.machine.locID3
          m.datLOC = this.datloc
          m.datLOC2 = this.datloc2
          m.datLOC3 = this.datloc3
        } else {
          m.locID = this.selectedWerfNr
          m.locID2 = this.machine.locID
          m.locID3 = this.machine.locID2
          m.datLOC = functions.vandaag2str()
          m.datLOC2 = this.datloc
          m.datLOC3 = this.datloc2
        }

        m.urofkm = this.huidigeurenstand
        m.omde = this.omde
        m.onderhurofkm = this.machine.onderhurofkm // gewoon overnemen??
        m.urofkm2 = this.vorigeurenstand
        m.datonderh = functions.date2str(this.datumvolgend)
        m.datvonderh = functions.date2str(this.datumvorig)
        m.geldigtot = this.geldigtot
        m.vorstvrij = this.vorstvrij?1:0
        m.defect = this.defect?1:0
        m.HL = this.HL?1:0
        m.VIK = this.VIK?1:0
        m.RIE = this.RIE?1:0
        m.CE = this.CE?1:0
        m.IDV = this.IDV?1:0
        m.opgenomenop = functions.date2str(this.datumurenopgenomenop)
        //functions.datornull2dat(functions.dat2strReverse(this.datumurenopgenomenop))
        m.onderhoudtekst = this.onderhoudtekst
        m.keuringopmtekst = this.keuringtekst
        m.omdemaanden = this.omdemaanden
        m.mapnaam = this.mapnaam

        if(this.ureningave == true) {
          m.datofuren = 0
        }
        if(this.datumingave == true) {
          m.datofuren = 1
        }
        if(this.infoingave == true) {
          m.datofuren = 2
        }

        m.merk = this.merk
        m.bouwjaar = this.bouwjaar
        m.serienr = this.serienr
        m.keuringinex = this.keuringinex

        datareq.setData('MachineOpslaan', m, this.jsonMachineOpslaan)
      },
      saveDialogOpslaan: function () {
        this.sluitennaopslaan = true
        this.machineOpslaan()
      },
      saveDialogNietOpslaan: function () {
        this.showSaveDialog = false
        this.$emit('backMaterieel')
      },
      saveDialogAnnuleren: function () {
        this.showSaveDialog = false
      },
      datumingaveClick: function () {
        this.datumingave = true
        this.ureningave = false
        this.infoingave = false
        this.dataGewijzigd()
      },
      ureningaveClick: function () {
        this.datumingave = false
        this.ureningave = true
        this.infoingave = false
        this.dataGewijzigd()
      },
      infoingaveClick: function () {
        this.datumingave = false
        this.ureningave = false
        this.infoingave = true
        this.dataGewijzigd()
      },
      nieuwOnderhoudClicked: function () {
        if(this.ureningave) {
          var txt = functions.date2strf(this.datumNieuwOnderhoud) + ' -- ' + 'urenstand: ' + this.huidigeurenstand + ' -- ' + this.nieuweonderhoudgegevens
          this.onderhoudtekst = txt + '\r' + this.onderhoudtekst
        }
        else if(this.datumingave) {
          var txt = functions.date2strf(this.datumNieuwOnderhoud) + ' -- ' + this.nieuweonderhoudgegevens
          this.onderhoudtekst = txt + '\r' + this.onderhoudtekst
        }
        else if(this.infoingave) {
          var txt = functions.date2strf(this.datumNieuwOnderhoud) + ' -- ' + this.nieuweonderhoudgegevens
          this.onderhoudtekst = txt + '\r' + this.onderhoudtekst
        }
        this.nieuweonderhoudgegevens = ''
        this.dataGewijzigd()
      },
      nieuwKeuringClicked: function () {
        var txt = functions.date2strf(this.datumNieuweKeuring) + ' -- ' + this.nieuwekeuringgegevens
        this.keuringtekst = txt + '\r' + this.keuringtekst
        this.nieuwekeuringgegevens = ''

        var mnd = this.datumNieuweKeuring

        this.geldigtot = new Date(mnd.setMonth(mnd.getMonth() + this.omdemaanden))//new Date(mnd.setMonth(mnd.getMonth() + 1 + this.omdemaanden))
        this.geldigtot = functions.date2str(this.geldigtot)

        this.dataGewijzigd()
      },
      omdemaandenClick: function (nr) {
        this.omdemaanden = nr
        this.dataGewijzigd()
      },
      keuringinexClick: function (nr) {
        this.keuringinex = nr
        this.dataGewijzigd()
      },
      clickFile: function (item) {
        var s = datareq.baseURL() + 'GetBestand.php?sid='
        s = s + this.sid + '&vid=' + this.vid + '&url=' + item.url + ''
        window.alert(s)
        window.open(
          s,
          '_blank' // <- This is what makes it open in a new window.
        )
      },
      nieuwePrimaryKeysMachine: function (data) {
        var status = data.status
        var d = data.data
        if (status === 'OK') {
          if(d === 1) {
            this.showWijzigVolgnrDialog = false
            this.laden([{sid: this.nieuweMachineSoort.soortID, vid: this.nieuweVolgnr}])
          } else if (d === 2) {
            this.TErrorWijzigVolgnr = 'Deze volgnr voor deze soort bestaat al.'
            this.TErrorShow = true
          }
        } else {
        }
      },
      WijzigVolgnrDialogClicked: function () {
        if(this.nieuweMachineSoort != null) {
          if(this.nieuweVolgnr != '') {
              datareq.getData('WijzigPrimaryKeysMachine', {soortID: this.soortID, volgID: this.volgnr, nieuwesoortID: this.nieuweMachineSoort.soortID, nieuwevolgID: this.nieuweVolgnr}, this.nieuwePrimaryKeysMachine)
          } else {
            this.TErrorWijzigVolgnr = 'Vul volgnummer in.'
            this.TErrorShow = true
          }
        } else {
          this.TErrorWijzigVolgnr = 'Kies een soort.'
          this.TErrorShow = true
        }
      }

    }
  }
</script>

<style lang="stylus">
  @import './stylus/main'

</style>
<style scoped>

.dateclass {
  background-color: #eeeeee;
  border: 2px solid gray;
  border-radius: 3px;
  padding-left: 5px;
  width: 120px;
  margin-left: 10px;
}

.group {
  display: flex;

   flex-flow: row wrap;

}

</style>



// WEBPACK FOOTER //
// materieeldetail.vue?6d9b1a80